export const appointmentKeys = {
  all: ["appointments"] as const,

  // The calendar lives under scheduleKeys now — GET /schedule replaced the two
  // /appointments/technician* routes these keys used to cache.

  details: () => [...appointmentKeys.all, "detail"] as const,
  detail: (id: number | string) => [...appointmentKeys.details(), id] as const,

  byWorkOrder: (workOrderId: string) =>
    [...appointmentKeys.all, "byWorkOrder", workOrderId] as const,

  series: (seriesId: string) => [...appointmentKeys.all, "series", seriesId] as const,
};
